/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AlertService } from '@kanzi-apes/kanzi-alerts';

@Injectable({
  providedIn: 'root'
})
export class FloormapUiService {
  zoom = 100;
  performOperation: Subject<any> = new Subject<any>();
  insertObject: Subject<any> = new Subject<any>();
  saveState = new Subject<any>();
  saveLayout = new Subject<any>();
  updateLayout = new Subject<boolean>();

  states:any[] = [];
  redoStates = [];
  selections: any[] = [];
  updatedFloor: any[] = [];
  updatedFloorLocations: any[] = [];
  deletedFloor: any[] = [];
  copied: any;
  ungroupable = false;
  roomEdit = false;

  constructor(private alertService: AlertService) {
    this.saveState.subscribe((res:any) => {
      this.states.push(res)
      this.redoStates = [];
    });
  }

  zoomIn() {
    if (this.zoom >= 150) {
      return;
    }
    this.zoom += 10;
    this.performOperation.next('ZOOM');
  }

  zoomOut() {
    if (this.zoom <= 20) {
      return;
    }
    this.zoom -= 10;
    this.performOperation.next('ZOOM');
  }

  delete() {
    if (this.selections.length === 0) {
      return;
    }
    this.performOperation.next('DELETE');
  }

  sendErrorMsg(msg: string) {
    this.alertService.error(msg);
  }
}
